<script lang="ts">
	import ShellLayout from "./ShellLayout.svelte";
	import Imprint from "./Imprint.svelte";
</script>

<ShellLayout><Imprint /></ShellLayout>
